import React, { useState } from "react";
import { ACCEPTED_IMAGE_EXTENSIONS_LIST, DEFAULT_IMAGE_MAX_FILE_SIZE_MB } from "./imageUtils";
import { ImageUploadCard } from "./ImageUploadCard";

interface ImageUploadPlaceholderProps {
	className?: string;
	hasError?: boolean;
	label?: string;
	onClick: () => void;
	onDrop?: (files: FileList) => void;
}

export const ImageUploadPlaceholder: React.FC<ImageUploadPlaceholderProps> = ({
	hasError = false,
	label,
	onClick,
	onDrop,
	className = "",
}) => {
	const [isDragOver, setIsDragOver] = useState(false);

	const handleDragEnter = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (e.dataTransfer.types.includes("Files")) {
			setIsDragOver(true);
		}
	};

	const handleDragOver = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const handleDragLeave = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (
			e.currentTarget === e.target ||
			!e.currentTarget.contains(e.relatedTarget as Node)
		) {
			setIsDragOver(false);
		}
	};

	const handleDrop = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragOver(false);
		if (e.dataTransfer.files?.length && onDrop) {
			onDrop(e.dataTransfer.files);
		}
	};

	return (
		<div
			className={`rounded ${isDragOver
				? "border-blue-400 bg-blue-100"
				: hasError
					? "border-red-400 bg-red-50"
					: "border-gray-300 bg-gray-50 hover:border-gray-400"
				} ${className}`}
			onClick={onClick}
			onDragEnter={handleDragEnter}
			onDragOver={handleDragOver}
			onDragLeave={handleDragLeave}
			onDrop={handleDrop}
		>
			<ImageUploadCard footer={label && <span className="text-xs">{label}</span>}>
				<span>
					{isDragOver ? "Drop to upload" : "Click or drop to upload"}
				</span>
			</ImageUploadCard>
		</div>
	);
};
